
import { stationOptions } from "constants/ticketConstants";

const getStationValue =( )=>{
  if(localStorage.getItem("lastUsedPrinter")){
    return stationOptions.find(s => s.value === localStorage.getItem("lastUsedPrinter"));
  }
  else{
    return { value: "", label: "None" };
  }
}

export const initialState = {
  stores: {
    allStores: [],
    error: null,
  },
  clerks: {
    allClerks: [],
    error: null,
  },
  tickets: {
    allTickets: [],
    page: 0,
    count: 0,
    error: null,
  },
  tickets_items: {
    items: [],
    ticketDetails: {},
    error: null,
  },
  addTicketFormdetails: {
    payment: { value: "cash", label: "Cash" },
    sex: { value: "M", label: "Male" },
    eyes: { value: "Bro", label: "Bro" },
    hair: { value: "Bro", label: "Bro" },
    booth: { name: "" },
    station: getStationValue(),
    copyTo: { value: "ticket", label: "Ticket" },
    race: { value: "", label: "None" },
    storeId: {},
    clerk: { id: "", first_name: "" },
    fromx: { name:"" },
    coupon: "",
    keyword: "",
    otherNo: "",
    otherIDNo: "",
    otherIDType: "",
    dLNo: "",
    dLExpirationDate: "",
    dLState: "",
    weight: "",
    height: "",
    dOB: "",
    zip: "",
    state: "",
    city: "",
    address: "",
    lastName: "",
    middleName: "",
    firstName: "",
    checkNumber: "4",
    paymentCheckAmount: "",
    ticketAmount: "",
    soldToAmountB: 0.0,
    copies: "1",
    soldToB: "",
    soldTo: "",
    soldToAmount: 0.0,
  },
  metroItemdetails: {
    items: [],
    count: 0,
  },
};


